import { useVideoContext } from "client/packages/player/player/VideoContext"
import { DEFAULT_SPLASH_IMAGE_URL } from "client/views/ChannelView/components/OfflineCard"
import styled from "styled-components"

import { useChannelContext } from "../channel"

export const SplashImageContainer = styled.div<{
  $splashImageUrl?: string
}>`
  width: 100%;
  height: 100%;

  background-image: ${(props) =>
    props.$splashImageUrl && `url(${props.$splashImageUrl})`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
`

const SplashImage = () => {
  const { live, recordingId, splashImageUrl } = useChannelContext()
  const { playerError } = useVideoContext()

  const liveOrVod = live || !!recordingId

  if (!liveOrVod || playerError) {
    return (
      <SplashImageContainer
        $splashImageUrl={splashImageUrl ?? DEFAULT_SPLASH_IMAGE_URL}
      />
    )
  }
  return null
}

export default SplashImage
